// (no direct React imports required in modern JSX)
import { MessageCircle } from 'lucide-react';

interface Props {
  onOpen?: () => void;
  onClick?: () => void;
  unread?: number;
}

export default function FloatingFamilyChatButton({ onOpen, onClick, unread = 0 }: Props) {
  const handle = onOpen || onClick;
  return (
    <button
      onClick={handle}
      aria-label="Öppna familjechatt"
      className="fixed right-4 bottom-28 md:bottom-8 z-[150] rounded-full w-14 h-14 shadow-lg flex items-center justify-center hover:scale-105 transition-transform"
      style={{ backgroundColor: '#67724e', color: '#ffffff', boxShadow: '0 8px 18px rgba(0,0,0,0.12)' }}
      onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.backgroundColor = '#56633f')}
      onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.backgroundColor = '#67724e')}
    >
      <MessageCircle className="h-6 w-6" />
      {unread > 0 && (
        <span className="absolute -top-1 -right-1 inline-flex items-center justify-center px-2 py-0.5 text-xs font-semibold leading-none text-white rounded-full" style={{ backgroundColor: '#945123' }}>
          {unread}
        </span>
      )}
    </button>
  );
}
